import clsx from 'clsx';
import type { FC } from 'react';
import { BUTTON_TEST_IDS } from './constants';
import classNames from './style';
import type { IButtonProps } from '~/components/actions/Button/types';
import Spinner from '~/components/actions/Button/components/Spinner';

import './style.css';

const Button: FC<IButtonProps> = ({
	children,
	className = '',
	disabled = false,
	type = 'button',
	isSubmitting = false,
	isFullWidth = false,
}) => {
	return (
		<button
			className={clsx(className, 'primary-button', classNames(isFullWidth))}
			disabled={disabled || isSubmitting}
			type={type}
			data-testid={BUTTON_TEST_IDS.ROOT}
		>
			{isSubmitting ? <Spinner /> : children}
		</button>
	);
};

export default Button;
